import React from 'react';

// Segmented picker for an assessment session's claim basis.
// value: '' (per Duration) | 'fa_1_2' (per Pax) | 'fa_2_2' (Final)
const SEGMENTS = [
  { value: '', title: 'None' },
  { value: 'fa_1_2', title: 'Assessment F.A. 1.2.' },
  { value: 'fa_2_2', title: 'Assessment F.A. 2.2.' },
];

export default function AssessmentBasisPicker({ value, onChange, name, disabled = false }) {
  const current = value || '';
  return (
    <div className="assessment-basis-group" role="radiogroup" aria-label="Assessment basis">
      {SEGMENTS.map(seg => {
        const active = current === seg.value;
        return (
          <label key={seg.value || 'duration'} className={`assessment-basis-option ${active ? 'is-selected' : ''} ${disabled ? 'is-disabled' : ''}`}>
            <input
              type="radio"
              name={name}
              value={seg.value}
              checked={active}
              disabled={disabled}
              onChange={() => onChange(seg.value)}
              className="session-type-radio"
            />
            <span className="assessment-basis-title">{seg.title}</span>
          </label>
        );
      })}
    </div>
  );
}
